export default __webpack_public_path__ + "static/media/heart_icon.0143021c.svg";